window.AwesomeHorizontalScrollbar = (function () {
	var generateDom = function () {
		return [
			'<div class="awesome-scrollbar m-horizontal" js-node="awesome-scrollbar">',
				'<div class="awesome-scrollbar__track m-horizontal" js-node="awesome-scrollbar__track">',
					'<div class="awesome-scrollbar__thumb m-horizontal" js-node="awesome-scrollbar__thumb"></div>',
				'</div>',
			'</div>'
		].join('\n');
	};

	var AwesomeHorizontalScrollbar = function (containerSelector, addClass) {
		addClass = ' ' + addClass || '';
		this.container = $(containerSelector);

		if (this.container.length < 1)
			return null;

		this.prevPageX = 0;

		this.container.wrap('<div class="awesome-scrollbar__area-wrapper' + addClass + '"><div class="awesome-scrollbar__content-wrapper m-horizontal"><div class="awesome-scrollbar__content"></div></div></div>');

		this.innerContainer = this.container.parent();
		this.outerContainer = this.innerContainer.parent();

		this.outerContainer.append(generateDom());

		this.scrollbarArea = this.outerContainer;
		this.scrollbarTrack = this.outerContainer.find('[js-node="awesome-scrollbar__track"]');
		this.scrollbarThumb = this.outerContainer.find('[js-node="awesome-scrollbar__thumb"]');
		this.scrollbarTrackWidth = this.scrollbarTrack.width();		

		var self = this;

		this.update();
	};	

	AwesomeHorizontalScrollbar.prototype.update = function () {

		var outerContainerWidth = this.outerContainer.first().width(),
				innerContainerWidth = this.innerContainer.first().width(),
				trackWidth = this.scrollbarTrack.width();

		this.unbindEvents();

		if (innerContainerWidth > outerContainerWidth) {
			this.scrollbarArea.removeClass('disabled');
			var thumbWidth = outerContainerWidth * 100 / innerContainerWidth;
			this.scrollbarThumb.width(thumbWidth + '%');
			this.bindEvents();
		} else {
			this.scrollbarArea.addClass('disabled');
		}
	};

	AwesomeHorizontalScrollbar.prototype.bindEvents = function () {
		var self = this;

		this.outerContainer.first().on('scroll.table', function (e) {
			self.scrollHandler($(this).scrollLeft());
		});

		this.scrollbarThumb.on('mousedown', function (e) {
			self.startDrag(e);
			self.prevPageX = (e.currentTarget.offsetWidth - (e.clientX - e.currentTarget.getBoundingClientRect().left));
		}).on('click', function (e) {
		    e.stopImmediatePropagation();
		});

		this.scrollbarArea.on('wheel', function (e) {
			self.scrollArea(e);			
			e.preventDefault();			
		}).on('click', function (e) {
			self.clickTrack(e);
		});

		return this;
	};

	AwesomeHorizontalScrollbar.prototype.unbindEvents = function () {
		var self = this;

		this.outerContainer.first().off('scroll.table');
		this.scrollbarThumb.off('mousedown');
		this.scrollbarArea.off('wheel').off('mouseenter').off('mouseleave').off('click').off('mousemove');

		return this;
	};

	AwesomeHorizontalScrollbar.prototype.scrollArea = function (e) {
		var scrollLeft;
		var currentScrollLeft = this.outerContainer.first().scrollLeft();

		if (e.originalEvent.deltaY > 0) {
			scrollLeft = currentScrollLeft + 20;
		} else {
			scrollLeft = currentScrollLeft - 20;
		}

		this.outerContainer.scrollLeft(scrollLeft);
	};

	AwesomeHorizontalScrollbar.prototype.clickTrack = function (e) {
		var offset = Math.abs(e.target.getBoundingClientRect().left - e.clientX),
				thumbHalf = (this.scrollbarThumb.get(0).offsetWidth / 2),
				thumbPositionPercentage = ((offset - thumbHalf) * 100 / this.scrollbarTrack.get(0).offsetWidth);

		var scrollLeft = (thumbPositionPercentage * this.outerContainer.get(0).scrollWidth / 100);
		this.outerContainer.scrollLeft(scrollLeft);
	};

	AwesomeHorizontalScrollbar.prototype.scrollHandler = function (scrollTop) {
		var x = scrollTop * 100 / this.outerContainer.first().width();

		this.scrollbarThumb.css({
			transform: 'translateX(' + x + '%)'
		});
	};

	AwesomeHorizontalScrollbar.prototype.clickThumbHandler = function (e) {
		this.startDrag(e);
		this.prevPageX = (e.currentTarget.offsetWidth - (e.clientX - e.currentTarget.getBoundingClientRect().left));
	};

	AwesomeHorizontalScrollbar.prototype.startDrag = function (e) {
		var self = this;
		e.stopImmediatePropagation();
		$('body').addClass('vertical-scroll-disable');
		self.scrollbarThumb.addClass('is-moving');

		function moveAt(e) {
			var offset = ((self.scrollbarTrack.get(0).getBoundingClientRect().left - e.clientX) * -1),
					thumbClickPosition = (self.scrollbarThumb.get(0).offsetWidth - self.prevPageX),
					thumbPositionPercentage = ((offset - thumbClickPosition) * 100 / self.scrollbarTrack.get(0).offsetWidth);

			var scrollLeft = thumbPositionPercentage * self.outerContainer.get(0).scrollWidth / 100;

			self.outerContainer.scrollLeft(scrollLeft);
		}

		$(document).on('mousemove', function (e) {
			moveAt(e);
		});

		$(document).on('mouseup', function (e) {
			$(document).off('mousemove');
			$(document).off('mouseup');
			$('body').removeClass('vertical-scroll-disable');
			self.scrollbarThumb.removeClass('is-moving');
			self.prevPageX = 0;
		});
	};

	return AwesomeHorizontalScrollbar;
}());